export const createSearchParams = (init = '') => {
  return new URLSearchParams(
    typeof init === 'string' ||
    Array.isArray(init) ||
    init instanceof URLSearchParams
      ? init
      : Object.entries(init).reduce(
          (acc, [key, value]) =>
            acc.concat(
              Array.isArray(value) ? [[key, value.join()]] : [[key, value]]
            ),
          []
        )
  );
};

export const getSearchParamsForLocation = (
  locationSearch,
  defaultSearchParams
) => {
  const searchParams = createSearchParams(locationSearch);

  if (defaultSearchParams) {
    defaultSearchParams.forEach((_, key) => {
      if (!searchParams.has(key)) {
        const value = defaultSearchParams.get(key);
        searchParams.append(key, value);
      }
    });
  }

  return searchParams;
};
